import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import Footer from "./components/Footer";
import { useFanClub } from "../contexts/AppContext";

export default function JelszoModositasPage() {
  const { changePassword } = useFanClub();
  const [formData, setFormData] = useState({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.password_confirmation) {
      toast.error('A két új jelszó nem egyezik.');
      return;
    }
    if (formData.password.length < 8) {
      toast.error('Az új jelszónak legalább 8 karakter hosszúnak kell lennie.');
      return;
    }
    setIsSubmitting(true);
    try {
      await changePassword(formData.current_password, formData.password);
      toast.success('Jelszó sikeresen módosítva.');
      setFormData({ current_password: '', password: '', password_confirmation: '' });
    } catch (err) {
      const msg = err.response?.data?.errors?.current_password?.[0]
        || err.response?.data?.errors?.password?.[0]
        || err.response?.data?.message
        || 'Hiba történt.';
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div data-testid="jelszo-modositas-page">
      <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-xl mx-auto">
          <div className="mb-8 sm:mb-16 animate-fade-in">
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Fan Club</p>
            <h1 className="text-3xl sm:text-5xl font-bold font-['Syne'] tracking-tighter">Jelszó módosítás</h1>
          </div>
          <div className="glass rounded-xl p-6 sm:p-8 animate-fade-in">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-xs font-medium mb-2 block">Jelenlegi jelszó</label>
                <Input
                  type="password"
                  value={formData.current_password}
                  onChange={(e) => setFormData(prev => ({ ...prev, current_password: e.target.value }))}
                  placeholder="••••••••"
                  required
                  className="bg-black/40 border-white/10 h-10 rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-xs font-medium mb-2 block">Új jelszó</label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
                  placeholder="Legalább 8 karakter"
                  required
                  minLength={8}
                  className="bg-black/40 border-white/10 h-10 rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-xs font-medium mb-2 block">Új jelszó megerősítése</label>
                <Input
                  type="password"
                  value={formData.password_confirmation}
                  onChange={(e) => setFormData(prev => ({ ...prev, password_confirmation: e.target.value }))}
                  placeholder="••••••••"
                  required
                  minLength={8}
                  className="bg-black/40 border-white/10 h-10 rounded-lg text-sm"
                />
              </div>
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full h-10 rounded-full bg-primary hover:bg-primary/90 font-bold text-sm mt-6"
              >
                {isSubmitting ? 'Mentés...' : 'Jelszó módosítása'}
              </Button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
